module.exports = __webpack_public_path__ + "img/tg_02 (5).03380934.jpg";